module.exports = __webpack_public_path__ + "static/Candida-Brito-c033993dee0912156fea8af4982edce7.jpg";